import * as angular from "angular";
import {IController, ILogService} from "angular";
import * as _ from "lodash";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {TaskModel} from "../../../tasks/models/task.model";

export class subTaskTemplateFormCtrl implements IController {

  form: any;
  subTask: any;
  actionOptions: any;
  tagTypes: string[];

  public treeOptions: any = {};

  onSubTaskChange: Function;

  /* @ngInject */
  constructor(private $log: ILogService,
              private commonsConstants,
              private commonsService: CommonsService) {
  }

  onAddAttachment() {
    this.commonsService.fileUpload(this.commonsConstants.fileConstants.upload.images)
      .then((result) => {
        this._afterUpload(result);
      })
      .catch(() => {
        this.$log.info('Closed File Upload')
      })
  }

  onRemoveAttachment(index: number) {
    const subTaskCopy = angular.copy(this.subTask);
    subTaskCopy.attachments.splice(index, 1);
    this.onSubTaskChange({subTask: subTaskCopy});
  }

  onServiceTimeChange(serviceTime) {
    const subTaskCopy = angular.copy(this.subTask);
    subTaskCopy.serviceTime = serviceTime;
    this.onSubTaskChange({subTask: subTaskCopy});
  }

  onToggleMandatory(isMandatory) {
    const subTaskCopy = angular.copy(this.subTask);
    subTaskCopy.mandatory = isMandatory;

    this.onSubTaskChange({subTask: subTaskCopy});
  }

  onSubTaskAddAction(action) {
    const subTaskCopy = angular.copy(this.subTask);
    if (!subTaskCopy.actions) {
      subTaskCopy.actions = [];
    }
    subTaskCopy.actions.unshift(action);
    this.onSubTaskChange({subTask: subTaskCopy});
  }

  onRemoveAction(index) {
    const subTaskCopy = angular.copy(this.subTask);
    subTaskCopy.actions.splice(index, 1);
    this.onSubTaskChange({subTask: subTaskCopy});
  }

  onActionTitleChanged() {
    const subTaskCopy = angular.copy(this.subTask);
    this.onSubTaskChange({subTask: subTaskCopy});
  }

  onTagsChange(tagNames) {
    const subTaskCopy = angular.copy(this.subTask);
    if (tagNames) {
      subTaskCopy.groupNames = tagNames;
    } else {
      delete subTaskCopy.groupNames;
    }

    this.onSubTaskChange({subTask: subTaskCopy});
  }

  onPdfFormTemplateChange(action, pdfFormTemplateId: string) {
    action.pdfFormTemplateId = pdfFormTemplateId;
    this.onSubTaskChange({subTask: this.subTask});
  }

  onOptionsChange(options, index) {
    const subTaskCopy = angular.copy(this.subTask);
    subTaskCopy.actions[index].dropdownOptions = options;

    this.onSubTaskChange({subTask: subTaskCopy});
  }

  private _afterUpload(result) {
    const imageUrl: any = _.get(result, 'url');
    const mimeType: any = _.get(result, 'contentType');

    if (imageUrl) {
      const attachment = {
        url: imageUrl,
        mimeType: mimeType
      };

      const subTaskCopy = angular.copy(this.subTask);

      if (!subTaskCopy.attachments) {
        subTaskCopy.attachments = [];
      }

      subTaskCopy.attachments.push(attachment);
      this.onSubTaskChange({subTask: subTaskCopy});
    }
  }

}

angular
  .module('bringoz.admin.sub-tasks')
  .component('subTaskTemplateForm', {
    require: {
      form: '^form'
    },
    bindings: {
      subTask: '<',
      actionOptions: '<',
      tagTypes: '<?',
      onSubTaskChange: '&'
    },
    template: require('./sub-task-template-form.html').default,
    controller: subTaskTemplateFormCtrl
  });
